exports = module.exports = require("../../../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-scripts/node_modules/css-loader?{"importLoaders":1}!./node_modules/react-scripts/node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Message Components/Video.css
// module id = ./node_modules/react-scripts/node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/react-scripts/node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/modules/screens/chatscreen/components/Message Components/Video.css
// module chunks = 121